<template>
    <form @submit="submitRegisterForm">
        <div v-if="initMemberRegistration" class="row">
            <div class="col-sm-12 col-lg-8">
                <h3 style="margin-bottom: 10px">
                    {{ t('Formlabels.Mitgliedskennung') }}
                </h3>
            </div>
            <div class="col-sm-12 col-lg-8">
                <div
                    class="reg-with-mitgliedskennung box-shadow-xyd mb"
                    style="margin-top: 0; padding: 0"
                >
                    <div class="row mb-small">
                        <div class="col-sm-12">
                            <div
                                class="mg-info mb-small text-small"
                                data-qa="mitgliedskennung-info-member-registration"
                                v-html="
                                    t('Register.MitgliedskennungInfoMemberReg')
                                "
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="crefo-input">
                                <div
                                    class="input-group"
                                    :class="{
                                        'has-error':
                                            !meta.valid &&
                                            errors.mitgliedskennung,
                                        'is-valid':
                                            !errors.mitgliedskennung &&
                                            values.mitgliedskennung
                                    }"
                                >
                                    <label for="registerFormMitgliedskennung">
                                        {{ t('Formlabels.Mitgliedskennung')
                                        }}<sup class="text-brand-red">*</sup>
                                    </label>
                                    <div class="input-wrapper">
                                        <InputText
                                            id="registerFormMitgliedskennung"
                                            v-model="
                                                registerMitgliedskennung.mitgliedskennung
                                            "
                                            data-no-crefo-ui="true"
                                            type="text"
                                            :placeholder="
                                                t('Formlabels.Mitgliedskennung')
                                            "
                                            name="mitgliedskennung"
                                            autocomplete="mitgliedsId"
                                            data-qa="registerFormMitgliedskennungInput"
                                        />
                                        <i
                                            class="crefo-ui-icon icon-check icon-color-blue"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <div
                                        v-if="errors.mitgliedskennung"
                                        class="error-msg"
                                    >
                                        <span>{{
                                            errors.mitgliedskennung
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="crefo-input">
                                <div
                                    class="input-group"
                                    :class="{
                                        'has-error':
                                            !meta.valid &&
                                            errors.allgemeinesPasswort,
                                        'is-valid':
                                            !errors.allgemeinesPasswort &&
                                            values.allgemeinesPasswort
                                    }"
                                >
                                    <label for="registerFormGeneralPassword">
                                        {{ t('Formlabels.GeneralPassword')
                                        }}<sup class="text-brand-red">*</sup>
                                    </label>
                                    <div
                                        class="input-wrapper has-visible-toggle password-hidden"
                                    >
                                        <InputText
                                            id="registerFormGeneralPassword"
                                            v-model="
                                                registerMitgliedskennung.allgemeinesPasswort
                                            "
                                            type="password"
                                            data-no-crefo-ui="true"
                                            :placeholder="
                                                t('Formlabels.GeneralPassword')
                                            "
                                            name="allgemeinesPasswort"
                                            data-qa="registerFormGeneralPasswordInput"
                                            autocomplete="registerFormGeneralPassword"
                                        />
                                        <a
                                            class="pw-toggle"
                                            :title="t('Password.show')"
                                            href="#"
                                        />
                                    </div>
                                    <div
                                        v-if="errors.allgemeinesPasswort"
                                        class="error-msg"
                                    >
                                        <span>{{
                                            errors.allgemeinesPasswort
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="crefo-input">
                                <div
                                    class="input-group"
                                    :class="{
                                        'has-error':
                                            !meta.valid &&
                                            errors.persoenlichesPasswort,
                                        'is-valid':
                                            !errors.persoenlichesPasswort &&
                                            values.persoenlichesPasswort
                                    }"
                                >
                                    <label for="registerFormPersonalPassword">
                                        {{ t('Formlabels.PersonalPassword')
                                        }}<sup class="text-brand-red">*</sup>
                                    </label>
                                    <div
                                        class="input-wrapper has-visible-toggle password-hidden"
                                    >
                                        <InputText
                                            id="registerFormPersonalPassword"
                                            v-model="
                                                registerMitgliedskennung.persoenlichesPasswort
                                            "
                                            type="password"
                                            :placeholder="
                                                t('Formlabels.PersonalPassword')
                                            "
                                            name="persoenlichesPasswort"
                                            data-qa="registerFormPersonalPasswordInput"
                                            autocomplete="registerFormPersonalPassword"
                                        />
                                        <a
                                            class="pw-toggle"
                                            :title="t('Password.show')"
                                            href="#"
                                        />
                                    </div>
                                    <div
                                        v-if="errors.persoenlichesPasswort"
                                        class="error-msg"
                                    >
                                        <span>{{
                                            errors.persoenlichesPasswort
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </div>
        <div class="row">
            <div v-if="initMemberRegistration" class="col-sm-12 col-lg-8">
                <h3>{{ t('Navigation.Profile') }}</h3>
            </div>
            <div class="col-sm-12 col-lg-8">
                <!-- Anrede -->
                <div class="crefo-input">
                    <div class="input-group has-error">
                        <label>{{ t('Formlabels.Salutation') }}</label>
                        <div class="radio-group">
                            <div class="input-wrapper">
                                <div class="crefo-radio">
                                    <div
                                        class="radio-btn"
                                        data-qa="registerFormSalutationCodeRadioMS"
                                    >
                                        <InputText
                                            id="salutationCode_MS"
                                            v-model="user.salutation"
                                            name="salutation"
                                            value="MS"
                                            type="radio"
                                        />
                                        <label for="salutationCode_MS">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t('Formlabels.Salutation.Ms')
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="crefo-radio">
                                    <div
                                        class="radio-btn"
                                        data-qa="registerFormSalutationCodeRadioMR"
                                    >
                                        <InputText
                                            id="salutationCode_MR"
                                            v-model="user.salutation"
                                            name="salutation"
                                            value="MR"
                                            type="radio"
                                        />
                                        <label for="salutationCode_MR">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t('Formlabels.Salutation.Mr')
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="crefo-radio">
                                    <div
                                        class="radio-btn"
                                        data-qa="registerFormSalutationCodeRadioMX"
                                    >
                                        <InputText
                                            id="salutationCode_MX"
                                            v-model="user.salutation"
                                            name="salutation"
                                            value="MX"
                                            type="radio"
                                        />
                                        <label for="salutationCode_MX">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t('Formlabels.Salutation.Mx')
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="crefo-radio">
                                    <div
                                        class="radio-btn"
                                        data-qa="registerFormSalutationCodeRadioUNKNOWN"
                                    >
                                        <InputText
                                            id="salutationCode_UNKNOWN"
                                            v-model="user.salutation"
                                            name="salutation"
                                            value="UNKNOWN"
                                            type="radio"
                                        />
                                        <label for="salutationCode_UNKNOWN">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t(
                                                    'Formlabels.Salutation.Unknown'
                                                )
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="!meta.valid && errors.salutation"
                            class="error-msg"
                        >
                            <span>{{ errors.salutation }}</span>
                        </div>
                    </div>
                </div>

                <!-- Vorname -->
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.firstName,
                            'is-valid': !errors.firstName && values.firstName
                        }"
                    >
                        <label for="profileUserdataFormFirstName">
                            {{ t('Formlabels.FirstName')
                            }}<sup class="text-brand-red">*</sup>
                        </label>
                        <div class="input-wrapper">
                            <InputText
                                id="profileUserdataFormFirstName"
                                v-model="user.firstName"
                                data-no-crefo-ui="true"
                                type="text"
                                :placeholder="t('Formlabels.FirstName')"
                                name="firstName"
                                autocomplete="given-name"
                                data-qa="registerFormFirstNameInput"
                                :disabled="submitting"
                            />
                            <i
                                class="crefo-ui-icon icon-check icon-color-blue"
                                aria-hidden="true"
                            />
                        </div>
                        <div v-if="errors.firstName" class="error-msg">
                            <span>{{ errors.firstName }}</span>
                        </div>
                    </div>
                </div>

                <!-- Nachname -->
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.surName,
                            'is-valid': !errors.surName && values.surName
                        }"
                    >
                        <label for="registerFormSurname">
                            {{ t('Formlabels.Surname')
                            }}<sup class="text-brand-red">*</sup>
                        </label>
                        <div class="input-wrapper">
                            <InputText
                                id="registerFormSurname"
                                v-model="user.surName"
                                data-no-crefo-ui="true"
                                type="text"
                                :placeholder="t('Formlabels.Surname')"
                                name="surName"
                                autocomplete="family-name"
                                data-qa="registerFormSurnameInput"
                                :disabled="submitting"
                            />
                            <i
                                class="crefo-ui-icon icon-check icon-color-blue"
                                aria-hidden="true"
                            />
                        </div>
                        <div
                            v-if="!meta.valid && errors.surName"
                            class="error-msg"
                        >
                            <span>{{ errors.surName }}</span>
                        </div>
                    </div>
                </div>

                <!-- Firma -->
                <div
                    v-if="showSmartSignUp"
                    class="crefo-input smart-signup-wrapper"
                >
                    <div
                        class="input-group smart-signup"
                        :class="{ disabled: showMitgliedskennung }"
                    >
                        <label>{{ t('Formlabels.CompanyName') }}</label>
                        <div
                            v-if="!showMitgliedskennung"
                            data-qa="smart-signup-wrapper"
                        >
                            <CrefoAutosuggestCompany
                                :placeholder-input="
                                    t(
                                        'Formlabels.CompanySearchValue.Placeholder'
                                    )
                                "
                                :suggestions="fetchCompanies"
                                name-input="companyName"
                                :value="selectedCompanyName"
                                @crefo-autosuggest-company-selected="
                                    onCompanySelected
                                "
                                @input="inputHandle"
                            />
                        </div>
                        <div
                            v-if="showMitgliedskennung"
                            data-qa="no-smartsignup-memberregistration"
                            class="crefo-ui-alert members-info"
                        >
                            {{
                                t(
                                    'Register.DisabledSmartSignupDueToMembershipRegistration'
                                )
                            }}
                        </div>
                    </div>
                </div>

                <!-- Email -->
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.email,
                            'is-valid': !errors.email && values.email
                        }"
                    >
                        <label for="registerFormEmail">
                            {{ t('Formlabels.Email')
                            }}<sup class="text-brand-red">*</sup>
                        </label>
                        <div class="input-wrapper">
                            <InputText
                                id="registerFormEmail"
                                v-model="user.email"
                                data-no-crefo-ui="true"
                                :placeholder="t('Formlabels.Email')"
                                name="email"
                                autocomplete="email"
                                data-qa="registerFormEmailInput"
                                :disabled="submitting"
                            />
                            <i
                                class="crefo-ui-icon icon-check icon-color-blue"
                                aria-hidden="true"
                            />
                        </div>
                        <div v-if="errors.email" class="error-msg">
                            <span>{{ errors.email }}</span>
                        </div>
                    </div>
                </div>

                <!-- Passwort -->
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.password,
                            'is-valid': !errors.password && values.password
                        }"
                    >
                        <label for="registerFormPassword">
                            {{ t('Formlabels.Password')
                            }}<sup class="text-brand-red">*</sup>
                        </label>
                        <div class="input-wrapper has-visible-toggle">
                            <InputText
                                id="registerFormPassword"
                                v-model="user.password"
                                data-no-crefo-ui="true"
                                type="password"
                                :placeholder="passwordPlaceholder"
                                name="password"
                                data-qa="registerFormPasswordInput"
                                :disabled="submitting"
                                autocomplete="registerFormPassword"
                            />
                            <a
                                class="pw-toggle"
                                data-qa="passwordVisibilityTestToggle"
                                :title="t('Password.show')"
                                href="#"
                            />
                        </div>
                        <div
                            v-if="errors.password"
                            class="error-msg"
                            data-qa="password-error-msg"
                        >
                            <span>{{ errors.password }}</span>
                        </div>
                        <div class="pt-small">
                            <span class="text-small">
                                {{
                                    t('Formlabels.PasswordHint', {
                                        hints: '! " # $ % & \' ( ) * + , - . / : ; < = > ? [ \\ _ ] ^ ` { | } ~'
                                    })
                                }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Passwort Wiederholung -->
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error':
                                !meta.valid && errors.confirmationPassword,
                            'is-valid':
                                !errors.confirmationPassword &&
                                values.confirmationPassword
                        }"
                    >
                        <label for="registerFormConfirmationPassword">
                            {{ t('Formlabels.ConfirmationPassword')
                            }}<sup class="text-brand-red">*</sup>
                        </label>
                        <div
                            class="input-wrapper has-visible-toggle password-hidden"
                        >
                            <InputText
                                id="registerFormConfirmationPassword"
                                v-model="user.confirmationPassword"
                                data-no-crefo-ui="true"
                                type="password"
                                :placeholder="passwordPlaceholder"
                                name="confirmationPassword"
                                data-qa="registerFormConfirmationPasswordInput"
                                :disabled="submitting"
                                autocomplete="registerFormConfirmationPassword"
                            />
                            <a
                                class="pw-toggle"
                                :title="t('Password.show')"
                                href="#"
                            />
                        </div>
                        <div
                            v-if="errors.confirmationPassword"
                            class="error-msg"
                        >
                            <span>{{ errors.confirmationPassword }}</span>
                        </div>
                    </div>
                </div>

                <div
                    v-if="!initMemberRegistration && showMemberChoice"
                    class="reg-with-mitgliedskennung box-shadow-xy mb"
                >
                    <div class="row mb-small">
                        <div class="col-sm-12">
                            <div
                                v-if="!initMemberRegistration"
                                class="mg-info mb-small"
                                data-qa="mitgliedskennung-info"
                                v-html="t('Register.MitgliedskennungInfo')"
                            />
                        </div>
                        <div class="col-sm-12">
                            <div class="crefo-input" style="margin-bottom: 0">
                                <div class="input-group has-error">
                                    <label
                                    >{{ t('Formlabels.WithCtoCredentials')
                                    }}<sup class="text-brand-red"
                                    >*</sup
                                    ></label
                                    >
                                    <div class="radio-group">
                                        <div class="input-wrapper">
                                            <div class="crefo-radio">
                                                <div
                                                    class="radio-btn"
                                                    data-qa="registerFormWithCtoCredentialsRadioYes"
                                                >
                                                    <InputText
                                                        id="withCtoCredentials_Yes"
                                                        name="withCto"
                                                        value="1"
                                                        type="radio"
                                                        @change="
                                                            updateShowMitgliedskennung
                                                        "
                                                    />
                                                    <label
                                                        for="withCtoCredentials_Yes"
                                                    >
                                                        <span class="radio-box"
                                                        ><span
                                                            class="radio-box-circle"
                                                        /></span>
                                                        <span
                                                            class="radio-label"
                                                        >{{
                                                            t(
                                                                'Formlabels.WithCtoCredentials.Yes'
                                                            )
                                                        }}</span
                                                        >
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="crefo-radio">
                                                <div
                                                    class="radio-btn"
                                                    data-qa="registerFormWithCtoCredentialsRadioNo"
                                                >
                                                    <InputText
                                                        id="withCtoCredentials_No"
                                                        name="withCto"
                                                        value="0"
                                                        type="radio"
                                                        @change="
                                                            updateShowMitgliedskennung
                                                        "
                                                    />
                                                    <label
                                                        for="withCtoCredentials_No"
                                                    >
                                                        <span class="radio-box"
                                                        ><span
                                                            class="radio-box-circle"
                                                        /></span>
                                                        <span
                                                            class="radio-label"
                                                        >{{
                                                            t(
                                                                'Formlabels.WithCtoCredentials.No'
                                                            )
                                                        }}</span
                                                        >
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="errors.withCto"
                                        class="error-msg"
                                    >
                                        <span>{{ errors.withCto }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="showMitgliedskennung" class="row">
                        <div class="col-sm-12 col-lg-8">
                            <div
                                class="reg-with-mitgliedskennung box-shadow-xyd mb"
                                style="margin-top: 0; padding: 0"
                            >
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="crefo-input">
                                            <div
                                                class="input-group"
                                                :class="{
                                                    'has-error':
                                                        !meta.valid &&
                                                        errors.mitgliedskennung,
                                                    'is-valid':
                                                        !errors.mitgliedskennung &&
                                                        values.mitgliedskennung
                                                }"
                                            >
                                                <label
                                                    for="registerFormMitgliedskennung"
                                                >
                                                    {{
                                                        t(
                                                            'Formlabels.Mitgliedskennung'
                                                        )
                                                    }}<sup
                                                        class="text-brand-red"
                                                    >*</sup
                                                    >
                                                </label>
                                                <div class="input-wrapper">
                                                    <InputText
                                                        id="registerFormMitgliedskennung"
                                                        v-model="
                                                            registerMitgliedskennung.mitgliedskennung
                                                        "
                                                        data-no-crefo-ui="true"
                                                        type="text"
                                                        :placeholder="
                                                            t(
                                                                'Formlabels.Mitgliedskennung'
                                                            )
                                                        "
                                                        name="mitgliedskennung"
                                                        autocomplete="mitgliedskennung"
                                                        data-qa="registerFormMitgliedskennungInput"
                                                    />
                                                    <i
                                                        class="crefo-ui-icon icon-check icon-color-blue"
                                                        aria-hidden="true"
                                                    />
                                                </div>
                                                <div
                                                    v-if="
                                                        errors.mitgliedskennung
                                                    "
                                                    class="error-msg"
                                                >
                                                    <span>{{
                                                        errors.mitgliedskennung
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="crefo-input">
                                            <div
                                                class="input-group"
                                                :class="{
                                                    'has-error':
                                                        !meta.valid &&
                                                        errors.allgemeinesPasswort,
                                                    'is-valid':
                                                        !errors.allgemeinesPasswort &&
                                                        values.allgemeinesPasswort
                                                }"
                                            >
                                                <label
                                                    for="registerFormGeneralPassword"
                                                >
                                                    {{
                                                        t(
                                                            'Formlabels.GeneralPassword'
                                                        )
                                                    }}<sup
                                                        class="text-brand-red"
                                                    >*</sup
                                                    >
                                                </label>
                                                <div
                                                    class="input-wrapper has-visible-toggle password-hidden"
                                                >
                                                    <InputText
                                                        id="registerFormGeneralPassword"
                                                        v-model="
                                                            registerMitgliedskennung.allgemeinesPasswort
                                                        "
                                                        type="password"
                                                        :placeholder="
                                                            t(
                                                                'Formlabels.GeneralPassword'
                                                            )
                                                        "
                                                        name="allgemeinesPasswort"
                                                        data-qa="registerFormGeneralPasswordInput"
                                                        autocomplete="registerFormGeneralPassword"
                                                    />
                                                    <a
                                                        class="pw-toggle"
                                                        :title="
                                                            t('Password.show')
                                                        "
                                                        href="#"
                                                    />
                                                </div>
                                                <div
                                                    v-if="
                                                        errors.allgemeinesPasswort
                                                    "
                                                    class="error-msg"
                                                >
                                                    <span>{{
                                                        errors.allgemeinesPasswort
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="crefo-input">
                                            <div
                                                class="input-group"
                                                :class="{
                                                    'has-error':
                                                        !meta.valid &&
                                                        errors.persoenlichesPasswort,
                                                    'is-valid':
                                                        !errors.persoenlichesPasswort &&
                                                        values.persoenlichesPasswort
                                                }"
                                            >
                                                <label
                                                    for="registerFormPersonalPassword"
                                                >
                                                    {{
                                                        t(
                                                            'Formlabels.PersonalPassword'
                                                        )
                                                    }}<sup
                                                        class="text-brand-red"
                                                    >*</sup
                                                    >
                                                </label>
                                                <div
                                                    class="input-wrapper has-visible-toggle password-hidden"
                                                >
                                                    <InputText
                                                        id="registerFormPersonalPassword"
                                                        v-model="
                                                            registerMitgliedskennung.persoenlichesPasswort
                                                        "
                                                        type="password"
                                                        :placeholder="
                                                            t(
                                                                'Formlabels.PersonalPassword'
                                                            )
                                                        "
                                                        name="persoenlichesPasswort"
                                                        data-qa="registerFormPersonalPasswordInput"
                                                        autocomplete="registerFormPersonalPassword"
                                                    />
                                                    <a
                                                        class="pw-toggle"
                                                        :title="
                                                            t('Password.show')
                                                        "
                                                        href="#"
                                                    />
                                                </div>
                                                <div
                                                    v-if="
                                                        errors.persoenlichesPasswort
                                                    "
                                                    class="error-msg"
                                                >
                                                    <span>{{
                                                        errors.persoenlichesPasswort
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>

                <!-- Marketing Einverständnis -->
                <div class="crefo-input pt-small">
                    <div class="input-group">
                        <div class="checkbox-group">
                            <div class="input-wrapper">
                                <div class="crefo-checkbox">
                                    <InputText
                                        id="registerFormConsentMarketing"
                                        v-model="user.consentMarketing"
                                        name="consentMarketing"
                                        type="checkbox"
                                        value="1"
                                        data-qa="registerFormConsentMarketingInput"
                                    />
                                    <label
                                        for="registerFormConsentMarketing"
                                        class="text-small"
                                        v-html="
                                            t('Formlabels.ConsentMarketing')
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Recherche Einverständnis -->
                <div class="crefo-input">
                    <div class="input-group">
                        <div class="checkbox-group">
                            <div class="input-wrapper">
                                <div class="crefo-checkbox">
                                    <InputText
                                        id="registerFormConsentRecherche"
                                        v-model="user.consentRecherche"
                                        type="checkbox"
                                        name="consentRecherche"
                                        value="1"
                                        data-qa="registerFormConsentRechercheInput"
                                        :disabled="submitting"
                                    />
                                    <label
                                        for="registerFormConsentRecherche"
                                        class="text-small"
                                    >{{
                                        t('Formlabels.ConsentRecherche')
                                    }}</label
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Nutzungsbedingungen -->
                <i18n-t
                    keypath="Register.IAcceptTOS"
                    scope="global"
                    tag="p"
                    class="pt-4 mb-8"
                >
                    <a
                        href="https://www.creditreform.de/datenschutz"
                        target="_blank"
                        rel="noopener"
                    >{{ t('Register.TOS') }}</a
                    >
                </i18n-t>

                <!-- Honigtopf -->
                <InputText
                    id="registerFormShippingAddressCity"
                    v-model="user.city"
                    type="hidden"
                    class="honey"
                    name="city"
                    data-qa="registerFormHoneypotInput"
                    autocomplete="shipping address-level4"
                />

                <div
                    v-if="
                        showResendWithoutMitgliedskennung &&
                            !initMemberRegistration
                    "
                    class="crefo-ui-alert error"
                >
                    {{ t('RegisterFailed.TryWithoutMitgliedskennung.Text') }}
                </div>
                <div
                    v-if="
                        showResendWithoutMitgliedskennung &&
                            initMemberRegistration
                    "
                    class="crefo-ui-alert error"
                >
                    {{ t('RegisterFailed.InvalidMitgliedskennung.Text') }}
                </div>
                <!-- Absenden -->
                <button
                    class="btn btn-default mb"
                    type="submit"
                    data-qa="registerFormSubmitButton"
                >
                    {{ t('Register') }}
                </button>

                <button
                    v-if="
                        showResendWithoutMitgliedskennung &&
                            !initMemberRegistration
                    "
                    class="btn btn-default mb"
                    style="margin-left: 15px"
                    data-qa="registerFormRetryWithoutMitgliedskennungSubmitButton"
                >
                    {{ t('RegisterFailed.TryWithoutMitgliedskennung.Button') }}
                </button>
            </div>
            <div class="col-sm-12 col-lg-8">
                <p class="text-italic text-small">
                    <sup class="text-brand-red">*</sup>
                    {{ t('Forms.required') }}
                </p>
            </div>
        </div>
    </form>
</template>

<script setup>
import CrefoAutosuggestCompany from '@dm/crefo-autosuggest-company'
import * as api from '@/services/user-management.js'
import { useI18n } from 'vue-i18n'
import { computed, ref, onMounted } from 'vue'
import { useForm } from 'vee-validate'
import getClientLangForIMS from '@/helper/imsLanguage'
import InputText from '@/components/customInputs/InputText'
import { useUserStore } from '@/store/module-user.js'
import { storeToRefs } from 'pinia'

const store = useUserStore()
const { t } = useI18n()
const {
    prk,
    prt,
    crefonummer,
    mitgliedskennung,
    hideSmartSignupExplicit,
    showSmartSignupExplicit,
    showMemberChoice,
    initMemberRegistration
} = defineProps({
    prk: {
        type: String,
        default: null
    },
    prt: {
        type: String,
        default: null
    },
    crefonummer: {
        type: String,
        default: null
    },
    mitgliedskennung: {
        type: String,
        default: null
    },
    hideSmartSignupExplicit: {
        type: Boolean,
        default: false
    },
    showSmartSignupExplicit: {
        type: Boolean,
        default: false
    },
    showMemberChoice: {
        type: Boolean,
        default: false
    },
    initMemberRegistration: {
        type: Boolean,
        default: false
    }
})

const user = ref({})
const registerMitgliedskennung = ref({})
const selectedCrefonummer = ref(null)
const selectedCompanyName = ref('')

const schema = {
    firstName: 'required|max:255',
    surName: 'required|max:255',
    email: 'ascii_only|required|email|max:255',
    password:
            'required|verify_mc_password_length|verify_mc_password_upper|verify_mc_password_lower|verify_mc_password_validChars|verify_mc_password_digit|verify_mc_password_specialChars',
    confirmationPassword: 'required|confirmed:password',
    salutation: 'required|included:MS,MR,MX,UNKNOWN',
    mitgliedskennung: 'digits:12|required_if:withCto',
    allgemeinesPasswort: 'required_if:withCto',
    persoenlichesPasswort: 'required_if:withCto',
    city: 'max:255'
}

const {
    getWebTargetData: webTarget,
    registrationFailedDueToCtoCredentials
} = storeToRefs(store)

const showMitgliedskennung = ref(false)

if (initMemberRegistration) {
    schema.mitgliedskennung = 'digits:12|required'
    schema.allgemeinesPasswort = 'required'
    schema.persoenlichesPasswort = 'required'
}

if (false === initMemberRegistration && showMemberChoice) {
    schema.withCto = 'required|included:1,0'
}

const updateShowMitgliedskennung = ({ target }) => {
    showMitgliedskennung.value = target.value === '1'

    if (target.value === '0') {
        if (user.value?.ctoZugangsdaten) {
            delete user.value.ctoZugangsdaten
        }
        registerMitgliedskennung.value = {}
    }
}

const {
    isSubmitting: submitting,
    meta,
    handleSubmit,
    values,
    errors,
    setFieldValue
} = useForm({
    validationSchema: schema
})

const showSmartSignUp = computed(() => {
    /**
         * Wenn die Registrierung explizit als Mitgliedsregistrierung angezeigt werden soll,
         * soll das Formularfeld explizit nicht angezeigt werden.
         */
    if (initMemberRegistration) {
        return false
    }

    /**
         * Wenn die Crefonummer von extern gesetzt wurde,
         * soll das Formularfeld unter keinen Umständen angezeigt werden.
         * Auch nicht wenn der Query-Parameter `showSmartSignup=1` übergeben wurde.
         */
    if (crefonummer !== null && crefonummer.length) {
        return false
    }
    /**
         * Wenn der Query-Parameter `showSmartSignup=1` übergeben wurde,
         * soll das Formularfeld explizit angezeigt werden.
         * Auch wenn die Anzeige in der Webtarget Konfiguration deaktiviert ist.
         */
    if (showSmartSignupExplicit) {
        return true
    }

    /**
         * Wenn der Query-Parameter `showSmartSignup=0` übergeben wurde,
         * soll das Formularfeld explizit nicht angezeigt werden.
         * Auch wenn die Anzeige in der Webtarget Konfiguration aktiviert ist.
         */
    if (hideSmartSignupExplicit) {
        return false
    }

    /**
         * Wenn in den `themeOpts` der Webtarget Konfiguration die Anzeige des Smart Sign Up Felds konfiguriert ist,
         * soll das Formularfeld entsprechend der Konfiguration angezeigt bzw. nicht angezeigt werden.
         */
    if (
        webTarget.value?.key !== null &&
            (webTarget.value?.themeOpts?.registration?.showSmartSignUp ===
                true ||
                webTarget.value?.themeOpts?.registration?.showSmartSignUp ===
                    false)
    ) {
        return webTarget.value.themeOpts.registration.showSmartSignUp
    }

    return true
})

const showResendWithoutMitgliedskennung = computed(() => {
    return (
        showMitgliedskennung.value &&
            registrationFailedDueToCtoCredentials.value
    )
})

const passwordPlaceholder = computed(() => {
    return !initMemberRegistration
        ? t('Formlabels.Password')
        : t('Formlabels.PasswordPlaceholder')
})

const fetchCompanies = searchQuery => {
    return api.searchSmartSignup(searchQuery)
}

const onCompanySelected = (company, index) => {
    selectedCrefonummer.value = company.crefonummer
}

const inputHandle = e => {
    selectedCrefonummer.value = null
    selectedCompanyName.value = e.target.value
    setFieldValue('companyName', e.target.value)
}

const submitRegisterForm = handleSubmit(
    values => {
        const userCrefonummer = selectedCrefonummer.value ?? crefonummer
        if (
            false === showMitgliedskennung.value &&
                userCrefonummer !== null &&
                userCrefonummer.length &&
                !initMemberRegistration
        ) {
            user.value.crefonummer = userCrefonummer
        }
        if (showMitgliedskennung.value || initMemberRegistration) {
            user.value.ctoZugangsdaten = {
                ...registerMitgliedskennung.value
            }
        }

        user.value.preferredLanguage = getClientLangForIMS()

        store.register(user.value)
    },
    ({ errors }) => {
        const firstError = Object.keys(errors)[0]
        const el = document.querySelector(`[name="${firstError}"]`)
        if (el) {
            // detect support for the behavior property in ScrollOptions
            const supportsNativeSmoothScroll =
                    'scrollBehavior' in document.documentElement.style

            if (supportsNativeSmoothScroll) {
                const offset = 100 // header + label
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top:
                            el.getBoundingClientRect().top -
                            offset +
                            window.scrollY
                })
            } else {
                el.scrollIntoView()
            }
        }
    }
)

onMounted(() => {
    if (mitgliedskennung !== null && mitgliedskennung.length) {
        showMitgliedskennung.value = true
        registerMitgliedskennung.value.mitgliedskennung = mitgliedskennung
    }
    if (initMemberRegistration) {
        showMitgliedskennung.value = true
    }

    user.value = {
        postRegistrationKey: prk,
        postRegistrationToken: prt,
        salutation: 'UNKNOWN'
    }
})
</script>

<style scoped lang="less">
    .honey {
        opacity: 0 !important;
        height: 0 !important;
        margin: 0 !important;
        position: absolute !important;
        top: -100px !important;
        left: -100px !important;
    }
    .input-wrapper {
        background-color: #ffffff;
    }
    .radio-label {
        padding-left: 0.5rem !important;
        min-width: 4rem;
        display: inline-block;
    }
    .text-small {
        font-size: 80% !important;
        line-height: 160% !important;
    }
</style>

<style lang="less">
    .pw-hint {
        .valid {
            color: #8acac1;
        }
        .invalid {
            color: #e05469;
        }
    }

    .smart-signup {
        &.disabled {
            .crefo-ui-alert.members-info {
                padding: 19.5px 20px;
            }
        }
    }
    @media (min-width: 992px) {
        .smart-signup-wrapper {
            height: 97px;
        }
    }

    .v-autocomplete-input::placeholder {
        color: #b5b5b5;
    }

    .v-autocomplete-list {
        position: absolute;
        left: -1px;
        top: 56px;
        width: calc(100% + 2px);
        z-index: 2;
        text-align: left;
        max-height: 405px;
        overflow-y: auto;
        border: 1px solid #b5b5b5;

        .v-autocomplete-list-item {
            cursor: pointer;
            background-color: #fff;
            padding: 18px;
            line-height: 1.5;
            color: #7f7f7f;
            border-bottom: 1px solid #b5b5b5;

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                background-color: #edece5;
            }
        }

        .v-autocomplete-item-active {
            color: #009ee2;
            background-color: #edece5;
        }
    }

    .crefo-input > .input-group > label + .input-wrapper {
        min-height: 58px;
    }

    .crefo-input {
        .input-group:hover {
            .input-wrapper {
                .v-autocomplete-list {
                    border-top-color: #009ee2;
                }
            }
        }
        .input-group.has-error:hover {
            .input-wrapper {
                .v-autocomplete-list {
                    border-top-color: #e05469;
                }
            }
        }
    }

    a.link-icon-prev.plus span,
    a.link-icon-prev.minus span {
        margin-left: 5px;
    }

    a.link-icon-prev.plus span:before {
        content: '\e90f';
        font-size: 13px;
        line-height: 15px;
        padding-top: 1px;
        left: -20px;
    }

    a.link-icon-prev.minus span:before {
        content: '\e90e';
        font-size: 13px;
        line-height: 15px;
        padding-top: 1px;
        left: -20px;
    }

    .mg-info {
        line-height: 24px;
    }

    .reg-with-mitgliedskennung {
        padding: 20px 30px 10px;
        margin-top: 40px;
    }
</style>
